export enum IssueVisibilityType {
	Archived = 1,
	Snoozed = 2,
	Visible = 3
}
